import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { SELECT_SEARCHED_TOPIC, logError, fetchSingleNote, fetchSingleTopic } from "../actions";
export default function onSelectSearchedTopic(action$, state$) {
    return action$.pipe(ofType(SELECT_SEARCHED_TOPIC), switchMap(function(action) {
        var actions = [];
        if (action.topic !== null) {
            if (action.app === "Note") {
                actions.push(fetchSingleNote({
                    note: action.topic
                }));
            } else {
                actions.push(fetchSingleTopic({
                    topic: action.topic
                }));
            }
        }
        return actions;
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "on_select_serched_topic"
        }));
    }));
}
